import { jsx as _jsx } from "react/jsx-runtime";
import { useHomeSwitchStore } from "src/store/homeSwitch.store";
import { BillingPlanSection, BrandSection, FreePromotion, ProductSection, SloganModule, StepSection } from "./components";
import HomeBanner from "./components/HomeBanner";
import QuickMenu from "./components/QuickMenu";
import { IpSelectSectionSkeleton } from "./components/Skeleton";
import IpSelectContainer from "./IpSelectSection/IpSelectContainer";
/** 섹션 타입별 렌더러 맵 */ const SECTION_RENDERERS = {
    ip_select: (section, ipSelectProps)=>{
        const ipSection = section;
        if (!ipSection.content) return null;
        // selectedBook이 아직 없으면 스켈레톤 표시
        if (!ipSelectProps) {
            return /*#__PURE__*/ _jsx("div", {
                className: "mx-auto w-[1200px]",
                children: /*#__PURE__*/ _jsx(IpSelectSectionSkeleton, {})
            });
        }
        return(// 과목 변경 시 응답 homeId를 key로 리마운트하여 필터 상태(selectedIndices)를 새 과목 기본값으로 초기화.
        // store homeId 대신 응답 homeId 사용: keepPreviousData 때문에 새 items 도착 시점에 맞춰 리마운트되어야 함.
        /*#__PURE__*/ _jsx(IpSelectContainer, {
            data: ipSection.content,
            selectedBook: ipSelectProps.selectedBook,
            onSelectSource: ipSelectProps.onSelectSource,
            isLoading: ipSelectProps.isLoading,
            isDefaultSelected: ipSelectProps.isDefaultSelected
        }, ipSelectProps.homeKey));
    },
    pr_image: (section, _ipSelectProps, homeId)=>{
        var _prImageSection_content, _prImageSection_content_;
        const prImageSection = section;
        var _prImageSection_content1;
        return /*#__PURE__*/ _jsx(FreePromotion, {
            content: (_prImageSection_content1 = prImageSection.content) !== null && _prImageSection_content1 !== void 0 ? _prImageSection_content1 : [],
            entityId: (_prImageSection_content = prImageSection.content) === null || _prImageSection_content === void 0 ? void 0 : (_prImageSection_content_ = _prImageSection_content[0]) === null || _prImageSection_content_ === void 0 ? void 0 : _prImageSection_content_.id,
            homeId: homeId
        });
    },
    brand_curation: (section, _ipSelectProps, homeId)=>{
        const curationSection = section;
        const content = curationSection.content[0];
        var _content_items;
        const brands = (_content_items = content === null || content === void 0 ? void 0 : content.items) !== null && _content_items !== void 0 ? _content_items : [];
        var _content_title, _content_header, _content_ctaButtonLink, _content_ctaButtonName, _content_imageUrl;
        return /*#__PURE__*/ _jsx(BrandSection, {
            title: (_content_title = content === null || content === void 0 ? void 0 : content.title) !== null && _content_title !== void 0 ? _content_title : "브랜드 추천",
            header: (_content_header = content === null || content === void 0 ? void 0 : content.header) !== null && _content_header !== void 0 ? _content_header : "",
            ctaButtonLink: (_content_ctaButtonLink = content === null || content === void 0 ? void 0 : content.ctaButtonLink) !== null && _content_ctaButtonLink !== void 0 ? _content_ctaButtonLink : "",
            ctaButtonName: (_content_ctaButtonName = content === null || content === void 0 ? void 0 : content.ctaButtonName) !== null && _content_ctaButtonName !== void 0 ? _content_ctaButtonName : "",
            titleImageUrl: (_content_imageUrl = content === null || content === void 0 ? void 0 : content.imageUrl) !== null && _content_imageUrl !== void 0 ? _content_imageUrl : "",
            brands: brands,
            entityId: content === null || content === void 0 ? void 0 : content.id,
            homeId: homeId
        });
    },
    handout_curation: (section, _ipSelectProps, homeId)=>{
        var _curationSection_content, _curationSection_content1, _curationSection_content2, _curationSection_content3, _curationSection_content4;
        const curationSection = section;
        const products = (_curationSection_content = curationSection.content) === null || _curationSection_content === void 0 ? void 0 : _curationSection_content.products;
        var _curationSection_content_title, _curationSection_content_header, _curationSection_content_ctaButtonLink, _curationSection_content_ctaButtonName;
        return /*#__PURE__*/ _jsx(ProductSection, {
            title: (_curationSection_content_title = (_curationSection_content1 = curationSection.content) === null || _curationSection_content1 === void 0 ? void 0 : _curationSection_content1.title) !== null && _curationSection_content_title !== void 0 ? _curationSection_content_title : "실시간 인기 자료",
            header: (_curationSection_content_header = (_curationSection_content2 = curationSection.content) === null || _curationSection_content2 === void 0 ? void 0 : _curationSection_content2.header) !== null && _curationSection_content_header !== void 0 ? _curationSection_content_header : "",
            ctaButtonLink: (_curationSection_content_ctaButtonLink = (_curationSection_content3 = curationSection.content) === null || _curationSection_content3 === void 0 ? void 0 : _curationSection_content3.ctaButtonLink) !== null && _curationSection_content_ctaButtonLink !== void 0 ? _curationSection_content_ctaButtonLink : "",
            ctaButtonName: (_curationSection_content_ctaButtonName = (_curationSection_content4 = curationSection.content) === null || _curationSection_content4 === void 0 ? void 0 : _curationSection_content4.ctaButtonName) !== null && _curationSection_content_ctaButtonName !== void 0 ? _curationSection_content_ctaButtonName : "",
            products: products,
            entityId: section.id,
            homeId: homeId,
            trackingEventName: "[Home] Handout Curation Section Clicked"
        });
    },
    new_handout: (section, _ipSelectProps, homeId)=>{
        var _newSection_content, _newSection_content1, _newSection_content2, _newSection_content3, _newSection_content4;
        const newSection = section;
        const products = (_newSection_content = newSection.content) === null || _newSection_content === void 0 ? void 0 : _newSection_content.products;
        var _newSection_content_title, _newSection_content_header, _newSection_content_ctaButtonLink, _newSection_content_ctaButtonName;
        return /*#__PURE__*/ _jsx(ProductSection, {
            title: (_newSection_content_title = (_newSection_content1 = newSection.content) === null || _newSection_content1 === void 0 ? void 0 : _newSection_content1.title) !== null && _newSection_content_title !== void 0 ? _newSection_content_title : "신규 등록 자료",
            header: (_newSection_content_header = (_newSection_content2 = newSection.content) === null || _newSection_content2 === void 0 ? void 0 : _newSection_content2.header) !== null && _newSection_content_header !== void 0 ? _newSection_content_header : "",
            ctaButtonLink: (_newSection_content_ctaButtonLink = (_newSection_content3 = newSection.content) === null || _newSection_content3 === void 0 ? void 0 : _newSection_content3.ctaButtonLink) !== null && _newSection_content_ctaButtonLink !== void 0 ? _newSection_content_ctaButtonLink : "",
            ctaButtonName: (_newSection_content_ctaButtonName = (_newSection_content4 = newSection.content) === null || _newSection_content4 === void 0 ? void 0 : _newSection_content4.ctaButtonName) !== null && _newSection_content_ctaButtonName !== void 0 ? _newSection_content_ctaButtonName : "",
            products: products,
            entityId: section.id,
            homeId: homeId,
            trackingEventName: "[Home] New Handout Section Clicked"
        });
    },
    billing_plan: (section, _ipSelectProps, homeId)=>{
        const billingSection = section;
        var _billingSection_categories;
        const categories = (_billingSection_categories = billingSection.categories) !== null && _billingSection_categories !== void 0 ? _billingSection_categories : [];
        var _billingSection_content;
        const content = (_billingSection_content = billingSection.content) !== null && _billingSection_content !== void 0 ? _billingSection_content : [];
        const firstContent = content[0];
        var _firstContent_header;
        return /*#__PURE__*/ _jsx(BillingPlanSection, {
            sectionTitle: (firstContent === null || firstContent === void 0 ? void 0 : firstContent.title) || "쏠북패스",
            header: (_firstContent_header = firstContent === null || firstContent === void 0 ? void 0 : firstContent.header) !== null && _firstContent_header !== void 0 ? _firstContent_header : "",
            categories: categories,
            content: content,
            buttonText: firstContent === null || firstContent === void 0 ? void 0 : firstContent.ctaButtonName,
            buttonUrl: firstContent === null || firstContent === void 0 ? void 0 : firstContent.ctaButtonLink,
            entityId: firstContent === null || firstContent === void 0 ? void 0 : firstContent.id,
            homeId: homeId
        });
    },
    step: (section, _ipSelectProps, homeId)=>{
        var _stepSection_content;
        const stepSection = section;
        const content = (_stepSection_content = stepSection.content) === null || _stepSection_content === void 0 ? void 0 : _stepSection_content[0];
        var _content_title, _content_header, _content_countDownText, _content_items;
        return /*#__PURE__*/ _jsx(StepSection, {
            title: (_content_title = content === null || content === void 0 ? void 0 : content.title) !== null && _content_title !== void 0 ? _content_title : "",
            header: (_content_header = content === null || content === void 0 ? void 0 : content.header) !== null && _content_header !== void 0 ? _content_header : "",
            useTimer: content === null || content === void 0 ? void 0 : content.useTimer,
            countdownText: (_content_countDownText = content === null || content === void 0 ? void 0 : content.countDownText) !== null && _content_countDownText !== void 0 ? _content_countDownText : "",
            steps: (_content_items = content === null || content === void 0 ? void 0 : content.items) !== null && _content_items !== void 0 ? _content_items : [],
            entityId: content === null || content === void 0 ? void 0 : content.id,
            homeId: homeId
        });
    },
    slogan: (section)=>{
        var _sloganSection_content;
        const sloganSection = section;
        // content가 배열이므로 첫 번째 요소 사용
        const sloganData = (_sloganSection_content = sloganSection.content) === null || _sloganSection_content === void 0 ? void 0 : _sloganSection_content[0];
        if (!sloganData) return null;
        return /*#__PURE__*/ _jsx("div", {
            className: "my-10 max-lg:mx-8 max-sm:mx-5 max-sm:my-6",
            children: /*#__PURE__*/ _jsx(SloganModule, {
                textRow1: sloganData.textRow1,
                textRow2: sloganData.textRow2,
                textColor1: sloganData.textColor1,
                textColor2: sloganData.textColor2,
                bgImageUrl: sloganData.bgImage
            })
        });
    },
    main_banner: (section, _ipSelectProps, homeId)=>{
        const bannerSection = section;
        if (!bannerSection.content) return null;
        return /*#__PURE__*/ _jsx(HomeBanner, {
            items: bannerSection.content,
            homeId: homeId
        });
    },
    quick_menu: (section, _ipSelectProps, homeId)=>{
        const menuSection = section;
        if (!menuSection.content) return null;
        return /*#__PURE__*/ _jsx(QuickMenu, {
            items: menuSection.content,
            homeId: homeId
        });
    }
};
const SectionRenderer = (param)=>{
    let { section , ipSelectProps , className =""  } = param;
    const homeId = useHomeSwitchStore((s)=>s.homeId);
    const renderer = SECTION_RENDERERS[section.sectionType];
    if (!renderer) return null;
    const backgroundColor = section.sectionType !== "ip_select" ? section.backgroundColor : undefined;
    return /*#__PURE__*/ _jsx("div", {
        className: "px-6 max-lg:px-0",
        style: backgroundColor ? {
            backgroundColor
        } : undefined,
        children: /*#__PURE__*/ _jsx("div", {
            className: className,
            children: renderer(section, ipSelectProps, homeId)
        })
    });
};
export default SectionRenderer;
